import * as React from "react";
import { SVGProps } from "react";
export const DriveSvgIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={63.85}
        height={54.851}
        viewBox="0 0 342 342"
        {...props}
    >
        <defs>
            <filter
                id="Rectangle_13562"
                x={0}
                y={0}
                filterUnits="userSpaceOnUse"
            >
                <feOffset dy={3} />
                <feGaussianBlur stdDeviation={3} result="blur" />
                <feFlood floodOpacity={0.161} />
                <feComposite operator="in" in2="blur" />
                <feComposite in="SourceGraphic" />
            </filter>
            <clipPath id="clip-path">
                <rect
                    id="Rectangle_13572"
                    data-name="Rectangle 13572"
                    transform="translate(0 0)"
                    fill="none"
                />
            </clipPath>
        </defs>
        <g
            id="Groupe_1026"
            data-name="Groupe 1026"
            transform="translate(-5388 6583)"
        >
            <g
                transform="matrix(1, 0, 0, 1, 5388, -6583)"
                filter="url(#Rectangle_13562)"
            >
                <rect
                    id="Rectangle_13562-2"
                    data-name="Rectangle 13562"
                    width={324}
                    height={324}
                    rx={50}
                    transform="translate(9 6)"
                    fill="#f8f8f6"
                />
            </g>
            <g
                id="Groupe_1006"
                data-name="Groupe 1006"
                transform="translate(5433.331 -6465.277)"
            >
                <g
                    id="Groupe_1005"
                    data-name="Groupe 1005"
                    clipPath="url(#clip-path)"
                >
                    <path
                        id="Trac\xE9_1409"
                        data-name="Trac\xE9 1409"
                        d="M251.288,47.947c0,5.478.053,10.956-.014,16.434a13.95,13.95,0,0,1-8.391,13.074,121.329,121.329,0,0,1-16.154,6.2c-1.809.564-2.212,1.562-2.9,2.838-4.772,8.884-12.081,14.074-22.291,14.065-10.33-.01-18.064-4.9-22.694-14.171-1.124-2.251-2.5-2.605-4.657-2.6q-52.8.063-105.6-.026a4.382,4.382,0,0,0-4.543,2.825c-4.6,9.083-12.1,14.014-22.271,13.967-10.091-.047-17.79-4.772-22.339-13.876-1.192-2.384-2.537-3.017-4.94-2.9-3.313.161-6.64.059-9.96.025C1.509,83.764.047,82.275.068,79.162c.059-8.8-.253-17.609.113-26.392.267-6.393,3.913-11.162,9.391-14.3A92.324,92.324,0,0,1,49.983,25.982a32.344,32.344,0,0,0,14.942-4.568C82.906,10.723,102.236,3.567,123.028,1.2c29.545-3.362,58.3.033,84.865,14.066,9.351,4.94,18.876,7.352,29.073,8.7,14.393,1.9,14.372,2.06,14.372,16.514v7.471h-.05M90.715,33.587c-10.289,0-20.579.071-30.867-.017A90.962,90.962,0,0,0,14.633,44.835C10.308,47.2,7.994,50.623,8.046,55.629c.059,5.641.087,11.285-.03,16.924-.045,2.2.4,3.807,2.91,3.1,2.078-.584,5.436,2.21,6.08-2.566,1.773-13.16,11.686-22.208,24.264-22.513,12.2-.3,23.169,8.775,25.308,21.561.515,3.074,1.347,3.662,4.171,3.646,19.749-.112,39.5-.166,59.246.035,3.758.038,4.265-1.351,4.215-4.583-.176-11.281-.234-22.57.033-33.847.075-3.14-.69-3.9-3.7-3.865-13.276.138-26.553.059-39.83.064M226.622,75.055c19.285-6.483,16.685-6.117,16.785-20.325.06-8.5.012-8.626-8.869-8.669-2.81-.014-3.46-.81-3.623-3.581-.227-3.847,1.078-5.08,4.742-4.549a30.979,30.979,0,0,0,4.97.033c1.274-.023,2.748.3,2.805-1.78.047-1.764.061-3.359-2.284-3.585a43.433,43.433,0,0,1-4.913-.659c-8.775-1.878-18.069-1.136-26.15-6.513-7.079-4.71-7.628-4.529-13.22,1.753-4.314,4.846-9.007,6.856-15.585,6.553-11.587-.533-23.217-.074-34.827-.2-2.8-.031-4.1.355-4.033,3.689.224,11.606.155,23.219.032,34.827-.028,2.631.408,3.819,3.448,3.75,8.953-.2,17.915-.169,26.87-.013,2.74.048,3.35-.8,3.809-3.529,1.73-10.288,7.581-17.521,17.736-20.511,15.809-4.654,29.368,5.162,32.307,23.313m-201.83.6c-.024,9.257,7.409,17.263,16.214,16.963,11.68-.4,17.379-7.571,17.769-17.01.436-10.533-7.109-16.089-21.089-16.336-6.2-.109-12.873,8.375-12.894,16.383m159.6-.19c-.021,9.417,7.221,17.463,16.135,17.121,11.644-.447,17.173-6.846,17.7-17.465.393-7.977-7.245-16.154-14.38-16.285-11.929-.219-19.429,6.192-19.451,16.629M164.894,25.5c5.3,0,10.625-.293,15.9.089,4.565.33,7.786-1.18,10.811-4.546,2.308-2.569,2.747-3.513-.967-4.784a147.64,147.64,0,0,0-44.156-8.052c-3.457-.092-4.291,1.048-4.032,4.2a52.492,52.492,0,0,1,0,8.936c-.286,3.2.7,4.377,4.06,4.235,6.119-.257,12.258-.073,18.388-.074m-88.961-.8c1.151,1.418,2.389.768,3.436.772,13.743.048,27.487.106,41.23-.012,4.424-.038,10.442,1.977,12.831-.9,2.21-2.663.411-8.486.8-12.881.266-3.006-.949-3.143-3.374-2.955a139.1,139.1,0,0,0-18.626,2.561A129.485,129.485,0,0,0,75.933,24.7"
                        fill="#0e0f0f"
                    />
                    <path
                        id="Trac\xE9_1410"
                        data-name="Trac\xE9 1410"
                        d="M90.715,33.585c13.277,0,26.554.076,39.829-.062,3.009-.032,3.774.725,3.7,3.865-.267,11.277-.209,22.566-.033,33.847.05,3.233-.458,4.621-4.215,4.583-19.747-.2-39.5-.147-59.246-.035-2.824.016-3.656-.571-4.171-3.645C64.439,59.351,53.471,50.281,41.27,50.577c-12.578.3-22.491,9.352-24.264,22.512-.644,4.777-4,1.982-6.08,2.566-2.506.705-2.956-.906-2.91-3.1.117-5.639.089-11.283.03-16.924-.052-5.005,2.262-8.427,6.587-10.793A90.973,90.973,0,0,1,59.847,33.57c10.289.088,20.579.017,30.868.015m22.582,12.4a25.772,25.772,0,0,1,3.971.033c3.61.568,4.454-1,4.31-4.393-.117-2.749-.758-3.922-3.656-3.7a63.127,63.127,0,0,1-8.445.012c-2.99-.175-4.814.028-4.832,4.033-.018,3.915,1.608,4.377,4.678,4.041a36.564,36.564,0,0,1,3.974-.024"
                        fill="#f7f7f4"
                    />
                    <path
                        id="Trac\xE9_1411"
                        data-name="Trac\xE9 1411"
                        d="M226.622,75.056c-2.938-18.152-16.5-27.967-32.308-23.313-10.154,2.99-16,10.222-17.735,20.51-.459,2.728-1.07,3.577-3.809,3.53-8.955-.156-17.916-.19-26.87.013-3.041.069-3.476-1.119-3.448-3.75.124-11.609.193-23.222-.031-34.827-.066-3.334,1.231-3.721,4.032-3.689,11.611.129,23.24-.33,34.826.2,6.579.3,11.272-1.707,15.586-6.553,5.592-6.282,6.142-6.463,13.22-1.753,8.082,5.377,17.375,4.634,26.151,6.513a43.187,43.187,0,0,0,4.912.658c2.345.226,2.331,1.822,2.284,3.585-.056,2.085-1.532,1.758-2.8,1.78a30.978,30.978,0,0,1-4.97-.032c-3.665-.532-4.97.7-4.743,4.548.163,2.772.814,3.568,3.623,3.581,8.881.044,8.929.173,8.87,8.669-.1,14.209,2.5,13.842-16.786,20.326"
                        fill="#f7f7f4"
                    />
                    <path
                        id="Trac\xE9_1412"
                        data-name="Trac\xE9 1412"
                        d="M24.792,75.659c.021-8.008,6.7-16.492,12.894-16.382,13.98.247,21.525,5.8,21.089,16.335-.39,9.44-6.089,16.612-17.769,17.01-8.805.3-16.238-7.706-16.214-16.963"
                        fill="#c07f50"
                    />
                    <path
                        id="Trac\xE9_1413"
                        data-name="Trac\xE9 1413"
                        d="M184.392,75.469c.023-10.436,7.522-16.847,19.451-16.628,7.135.131,14.774,8.307,14.38,16.284-.523,10.62-6.052,17.018-17.7,17.465-8.914.343-16.155-7.7-16.135-17.121"
                        fill="#c07f50"
                    />
                    <path
                        id="Trac\xE9_1414"
                        data-name="Trac\xE9 1414"
                        d="M164.894,25.5c-6.13,0-12.268-.184-18.388.074-3.362.141-4.346-1.03-4.06-4.235a52.4,52.4,0,0,0,0-8.937c-.259-3.148.575-4.288,4.032-4.195a147.614,147.614,0,0,1,44.157,8.051c3.713,1.272,3.274,2.215.966,4.784-3.025,3.366-6.246,4.877-10.811,4.546-5.274-.382-10.6-.089-15.9-.088"
                        fill="#f7f7f4"
                    />
                    <path
                        id="Trac\xE9_1415"
                        data-name="Trac\xE9 1415"
                        d="M75.933,24.7a129.485,129.485,0,0,1,36.3-13.417,139.1,139.1,0,0,1,18.626-2.561c2.425-.188,3.64-.051,3.374,2.955-.39,4.4,1.409,10.218-.8,12.881-2.389,2.879-8.407.864-12.831.9-13.743.118-27.487.06-41.23.012-1.047,0-2.285.646-3.436-.772"
                        fill="#f7f7f4"
                    />
                    <path
                        id="Trac\xE9_1416"
                        data-name="Trac\xE9 1416"
                        d="M113.3,45.986a36.564,36.564,0,0,0-3.974.024c-3.07.336-4.7-.126-4.678-4.041.018-4.005,1.842-4.208,4.832-4.033a63.127,63.127,0,0,0,8.445-.012c2.9-.219,3.539.953,3.656,3.7.144,3.4-.7,4.961-4.31,4.393a25.772,25.772,0,0,0-3.971-.033"
                        fill="#0e0f0f"
                    />
                </g>
            </g>
        </g>
    </svg>
);
